//#region imports
import customAxios from '../../utils/customAxios';
import React, { useState, useEffect } from 'react';

import { DataGridPro } from '@mui/x-data-grid-pro';

import { Tooltip } from '@mui/material';

import { Stack } from '@mui/system';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAdd,
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
} from '@fortawesome/free-solid-svg-icons';

import {
  DeleteOutlineOutlined as DeleteIcon,
  AssignmentOutlined as ReportsIcon,
  ContentCopyOutlined,
} from '@mui/icons-material';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import ModalQ from '../Modal/Create/ModalQ';
import { useTranslationHook } from '../../hooks/UseTranslationHook';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import ModalAllQDelete from '../Modal/Delete/ModalAllQDelete';
import { GlobalVariables } from '../../globalVar';
import Directory from '../Questionnaire/Directory';
import Toolbar from '../Questionnaire/Toolbar';

import { useManageReturnToAllQ } from '../../hooks/UseManageReturnToAllQ';
import { Reports } from './ReportsTable';
import { ConfigQuestions } from './QuestionsTable';
import { useTableLocale } from '../../hooks/useTableLocale';
import { useUserPermissions } from '../../hooks/userPermissions';

library.add(
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble
);

//#endregion

export const ConfigAllQuestionnaires = () => {
  const userPermissions = useUserPermissions();

  // hooks configuration
  const [allQData, setAllQData] = useState([]);

  const [modalQShow, setModalQShow] = useState(false);
  const [modalAllQDeleteShow, setModalAllQDeleteShow] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  // States to handle directory component
  const [directoryData, setDirectoryData] = useState([]); // Sections data of the selected questionnaire
  const [isDirectoryLoading, setIsDirectoryLoading] = useState(true);

  // States to handle modals (on ConfigQuestions with Toolbar)
  const [modalQuestionShow, setModalQuestionShow] = useState(false);
  const [modalMessageShow, setModalMessageShow] = useState(false);
  const [modalSectionShow, setModalSectionShow] = useState(false);
  const [modalLoopShow, setModalLoopShow] = useState(false); // Future functionality
  const [modalCondShow, setModalCondShow] = useState(false); // Future functionality
  const [modalTableShow, setModalTableShow] = useState(false); // Future functionality

  // State to handle multiple delete functionality (on ConfigQuestions with Toolbar)
  const [modalQMultipleDeleteShow, setModalQMultipleDeleteShow] =
    useState(false);

  // State to handle the selectedQuestionnaire
  const [selectedQuestionnaire, setSelectedQuestionnaire] = useState(null);

  // State to handle the selectedSection in the directory
  const [selectedSection, setSelectedSection] = useState(null);

  // State to handle the selected section name
  const [sectionName, setSectionName] = useState('Sección Principal');

  // State to handle the selected questionnaire to view reports
  const [selectedQForReports, setSelectedQForReports] = useState(null);

  const { t } = useTranslation();

  const {
    questionnarieQNameString,
    questionnarieQDescriptionString,
    questionnarieQVTypeString,
    noQuestionnariesString,
    loadingString,
    detailString,
    addQString,
    deleteString,
    backToQString,
    viewQuestionsString,
    viewReportsTooltip,
  } = useTranslationHook();

  const {
    showAllQ,
    setShowAllQ,
    showQ,
    setShowQ,
    showReports,
    setShowReports,
    manageReturnToAllQ,
  } = useManageReturnToAllQ();

  const locale = useTableLocale();

  useEffect(() => {
    const updateAllQData = () => {
      setAllQData((prevData) => {
        return prevData.map((questionnarie) => ({
          ...questionnarie,
        }));
      });
    };
    i18next.on('languageChanged', updateAllQData);

    return () => {
      i18next.off('languageChanged', updateAllQData);
    };
  }, [t]);

  const endpoint = `${GlobalVariables.getURL()}listQuestionaries`;

  /**
   * Function to obtain information from all questionnaires
   * @returns {any} Data from all questionnaires to populate the table
   */
  const getData = async () => {
    setIsLoading(true);

    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      const allQData = response.data.map((questionnarie) => {
        return {
          ...questionnarie,
        };
      });
      setAllQData(allQData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  /**
   * Function to obtain sectiones from selected questionnaire
   * @returns {any} Data from all sections to populate the directory
   */
  const getDirectoryData = async () => {
    setIsDirectoryLoading(true);
    let directoryEndpoint;

    if (selectedQuestionnaire != null) {
      directoryEndpoint = `${GlobalVariables.getURL()}sectionsFromQuestionnaire/${selectedQuestionnaire}`;
    } else {
      setIsDirectoryLoading(false);
      return;
    }

    try {
      const response = await customAxios.get(directoryEndpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      const directoryData = response.data.map((section) => {
        return {
          ...section,
        };
      });
      setDirectoryData(directoryData);
      setIsDirectoryLoading(false);
      return directoryData;
    } catch (error) {
      console.log(error);
      setIsDirectoryLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (selectedQuestionnaire !== null) {
      getDirectoryData().then((data) => {
        if (data.length > 0) {
          const firstSectionId = data[0].id;
          if (firstSectionId !== selectedSection) {
            setSelectedSection(firstSectionId);
          }
        }
      });
    }
  }, [selectedQuestionnaire]);

  useEffect(() => {
    setSectionName('Sección Principal');
  }, [selectedQuestionnaire]);

  useEffect(() => {
    // Nothing to do in this useEffect
  }, [isLoading]);

  useEffect(() => {
    // Nothing to do in this useEffect
  }, [isDirectoryLoading]);

  /**
   * Function to determine the selected questionnaire information to be displayed in the delete modal
   * @param {Object} qInfo - Object of the selected row, i.e. selected questionnaire
   * @param {string} qInfo.id - The ID of the questionnaire
   * @param {string} qInfo.name - The name of the questionnaire
   * @param {string} qInfo.description - The description of the questionnaire
   */
  function manageAllQDelete(qInfo) {
    var qId = qInfo.id;
    var qName = qInfo.name;
    var qDesc = qInfo.description;
    localStorage.setItem('qIdForDelete', qId);
    localStorage.setItem('qNameToDelete', qName);
    localStorage.setItem('qDescToDelete', qDesc);
  }

  /**
   * Function to display the questions of the selected questionnaire
   * @param {Object} qInfo - Object of the selected row, i.e. selected questionnaire
   * @param {string} qInfo.id - The ID of the questionnaire
   * @param {string} qInfo.name - The name of the questionnaire
   */
  function manageShowQuestions(qInfo) {
    // Extract information from the provided qInfo object
    var qId = qInfo.id;
    setSelectedQuestionnaire(qId);
    var qName = qInfo.name;

    // Store information in localStorage for later use
    localStorage.setItem('qIdForShow', qId);
    localStorage.setItem('qNameForShow', qName);

    // Update state variables to control the visibility of components
    setShowAllQ(false);
    setShowQ(true);
    setShowReports(false);
  }

  /**
   * Function to display the reports of the selected questionnaire
   * @param {Object} qInfo - Object of the selected row, i.e. selected questionnaire
   * @param {string} qInfo.id - The ID of the questionnaire
   */
  function manageShowReports(qInfo) {
    // Extract information from the provided qInfo object
    var qId = qInfo.id;
    setSelectedQForReports(qId);

    // Update state variables to control the visibility of Reports datagrid
    setShowReports(true);
    setShowAllQ(false);
    setShowQ(false);
  }

  const actionColumn = [
    {
      field: 'action',
      headerName: detailString,
      width: 160,
      renderCell: (params) => {
        return (
          <div className='cellAction'>
            {userPermissions.includes('Read Questionary') && (
              <Tooltip title={viewQuestionsString} arrow>
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    marginTop: '5px',
                  }}
                  onClick={() => {
                    manageShowQuestions(params.row);
                  }}
                >
                  <VisibilityOutlinedIcon className='detail-icons' />
                </button>
              </Tooltip>
            )}
            {userPermissions.includes('Read Questionary') && (
              <Tooltip title={viewReportsTooltip} arrow>
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    marginTop: '5px',
                  }}
                  onClick={() => {
                    manageShowReports(params.row);
                  }}
                >
                  <ReportsIcon className='detail-icons' />
                </button>
              </Tooltip>
            )}
            <Tooltip title='Duplicar' arrow>
              <button
                style={{
                  display: 'none',
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  marginTop: '5px',
                }}
                onClick={() => {}}
              >
                <ContentCopyOutlined className='detail-icons' />
              </button>
            </Tooltip>
            {userPermissions.includes('Delete Questionary') && (
              <Tooltip title={deleteString} arrow>
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    marginTop: '5px',
                  }}
                  onClick={() => {
                    setModalAllQDeleteShow(true);
                    manageAllQDelete(params.row);
                  }}
                >
                  <DeleteIcon className='detail-icons' id='delete-icon' />
                </button>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];

  // Columns
  const allQColumns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 70,
    },
    {
      field: 'name',
      headerName: questionnarieQNameString,
      width: 200,
    },
    {
      field: 'description',
      headerName: questionnarieQDescriptionString,
      width: 350,
    },
    // Map through all columns and add default renderCell if not already defined
  ].map((col) =>
    col.renderCell
      ? col
      : {
          ...col,
          renderCell: (params) =>
            params.row[col.field] ? params.row[col.field] : '-',
        }
  );

  // Check if user has any action permissions
  const hasActionPermissions =
    userPermissions.includes('Read Questionary') ||
    userPermissions.includes('Delete Questionary');

  return (
    <div className='full-container'>
      {showAllQ && userPermissions.includes('List Questionaries') && (
        <div className='full-datatables-container'>
          <div style={{ marginTop: '1%', marginBottom: '1%' }}>
            {userPermissions.includes('Create Questionary') && (
              <button
                className='add-button'
                onClick={() => setModalQShow(true)}
              >
                {addQString} <FontAwesomeIcon icon={faAdd} />
              </button>
            )}
          </div>

          <ModalQ
            show={modalQShow}
            onHide={() => setModalQShow(false)}
            getQuestionnaires={getData}
          />

          <ModalAllQDelete
            show={modalAllQDeleteShow}
            onHide={() => setModalAllQDeleteShow(false)}
            getQuestionnaires={getData}
          />

          <DataGridPro
            localeText={locale.components.MuiDataGrid.defaultProps.localeText}
            pagination
            loading={isLoading}
            initialState={{
              sorting: {
                sortModel: [{ field: 'id', sort: 'desc' }],
              },
              columns: {
                columnVisibilityModel: {
                  id: false,
                },
              },
              pinnedColumns: hasActionPermissions ? { right: ['action'] } : {},
            }}
            rows={allQData}
            columns={
              hasActionPermissions
                ? allQColumns.concat(actionColumn)
                : allQColumns
            }
            pageSize={10}
            disableSelectionOnClick
            slots={{
              noRowsOverlay: () => (
                <Stack
                  height='100%'
                  alignItems='center'
                  justifyContent='center'
                >
                  {noQuestionnariesString}
                </Stack>
              ),
            }}
          />
        </div>
      )}
      {showQ && userPermissions.includes('Read Questionary') && (
        <div className='full-qquestions-container'>
          <div className='directory-container'>
            <Directory
              manageReturnToAllQ={manageReturnToAllQ}
              setSelectedSection={setSelectedSection}
              selectedSection={selectedSection}
              selectedQuestionnaire={selectedQuestionnaire}
              setSectionName={setSectionName}
              directoryData={directoryData}
              isDirectoryLoading={isDirectoryLoading}
            />
          </div>
          <div className='questions-detail-container'>
            <div className='toolbar-container'>
              <Toolbar
                isButtonDisabled={isButtonDisabled}
                rowSelectionModel={rowSelectionModel}
                sectionName={sectionName}
                setModalQuestionShow={setModalQuestionShow}
                setModalMessageShow={setModalMessageShow}
                setModalSectionShow={setModalSectionShow}
                setModalQMultipleDeleteShow={setModalQMultipleDeleteShow}
              />
            </div>
            <div className='questions-datatable-container'>
              <ConfigQuestions
                setIsButtonDisabled={setIsButtonDisabled}
                rowSelectionModel={rowSelectionModel}
                setRowSelectionModel={setRowSelectionModel}
                selectedSection={selectedSection}
                setSelectedSection={setSelectedSection}
                selectedQuestionnaire={selectedQuestionnaire}
                modalQuestionShow={modalQuestionShow}
                modalMessageShow={modalMessageShow}
                modalSectionShow={modalSectionShow}
                modalQMultipleDeleteShow={modalQMultipleDeleteShow}
                setModalQuestionShow={setModalQuestionShow}
                setModalMessageShow={setModalMessageShow}
                setModalSectionShow={setModalSectionShow}
                setModalQMultipleDeleteShow={setModalQMultipleDeleteShow}
                getDirectoryData={getDirectoryData}
              />
            </div>
          </div>
        </div>
      )}
      {showReports && userPermissions.includes('Read Questionary') && (
        <div className='reports-container'>
          <Reports
            selectedQForReports={selectedQForReports}
            manageReturnToAllQ={manageReturnToAllQ}
          />
        </div>
      )}
    </div>
  );
};
